import React, { createContext, useState, useContext, useEffect } from "react";

// Create Context
const PrzelewyPaginationContext = createContext();

const storageKeys = (generated) => {
	const suffix = generated ? "Generated" : "";

	return {
		current: `currentPageMSRPrzelewy${suffix}`,
		pagesize: `MSRPagesizePrzelewy${suffix}`,
		search: `searchPrzelewy${suffix}`,
		advancedSearch: `advancedSearchMSRPrzelewy${suffix}`,
	};
};

const readStoredValue = (key, fallback) => {
	const value = localStorage.getItem(key);
	return value === null ? fallback : JSON.parse(value);
};

// Custom Hook to use the Pagination Context
export const usePaginationPrzelewy = () => {
	return useContext(PrzelewyPaginationContext);
};

// PaginationProvider Component
export const PaginationProviderPrzelewy = ({ children }) => {
	const [pagination, setPagination] = useState({
		current: readStoredValue(storageKeys(false).current, 1),
		pagesize: readStoredValue(storageKeys(false).pagesize, 20),
		loading: false,
		generated: false,
		search: readStoredValue(storageKeys(false).search, null),
		advancedSearch: readStoredValue(
			storageKeys(false).advancedSearch,
			null,
		),
		orderby: [],
		reload: false,
	});

	// Update localStorage whenever pagination state changes
	useEffect(() => {
		const keys = storageKeys(pagination.generated);
		localStorage.setItem(keys.current, JSON.stringify(pagination.current));
		localStorage.setItem(
			keys.advancedSearch,
			JSON.stringify(pagination.advancedSearch),
		);
		localStorage.setItem(
			keys.pagesize,
			JSON.stringify(pagination.pagesize),
		);
		localStorage.setItem(keys.search, JSON.stringify(pagination.search));
	}, [pagination]);

	const setGenerated = (generated) => {
		const keys = storageKeys(generated);

		setPagination((previous) => ({
			...previous,
			generated,
			current: readStoredValue(keys.current, 1),
			pagesize: readStoredValue(keys.pagesize, 20),
			search: readStoredValue(keys.search, null),
			advancedSearch: readStoredValue(keys.advancedSearch, null),
			loading: false,
		}));
	};

	return (
		<PrzelewyPaginationContext.Provider
			value={{ pagination, setPagination, setGenerated }}
		>
			{children}
		</PrzelewyPaginationContext.Provider>
	);
};
